/**
 * Klab MMP Report API
 *
 * Contact: jesuspalominomartinez1234@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ExportFormatEnum = {
    Pdf: 'PDF',
    Csv: 'CSV',
    Excel: 'EXCEL'
} as const;
export type ExportFormatEnum = typeof ExportFormatEnum[keyof typeof ExportFormatEnum];

